import _t from "@monaco-editor/loader";
import { memo as Te } from "react";
import ke, { useState as re, useRef as S, useCallback as oe, useEffect as ne } from "react";
import Se from "@monaco-editor/loader";
import { memo as ye } from "react";
import K from "react";
var le = {
    wrapper: {
      display: "flex",
      position: "relative",
      textAlign: "initial"
    },
    fullWidth: {
      width: "100%"
    },
    hide: {
      display: "none"
    }
  },
  v = le;
import me from "react";
var ae = {
    container: {
      display: "flex",
      height: "100%",
      width: "100%",
      justifyContent: "center",
      alignItems: "center"
    }
  },
  Y = ae;
function Me(_ref) {
  let {
    children: e
  } = _ref;
  return me.createElement("div", {
    style: Y.container
  }, e);
}
var Z = Me;
var $ = Z;
function Ee(_ref2) {
  let {
    width: e,
    height: r,
    isEditorReady: n,
    loading: t,
    _ref: a,
    className: m,
    wrapperProps: E
  } = _ref2;
  return K.createElement("section", {
    style: {
      ...v.wrapper,
      width: e,
      height: r
    },
    ...E
  }, !n && K.createElement($, null, t), K.createElement("div", {
    ref: a,
    style: {
      ...v.fullWidth,
      ...(!n && v.hide)
    },
    className: m
  }));
}
var ee = Ee;
var H = ye(ee);
import { useEffect as xe } from "react";
function Ce(e) {
  xe(e, []);
}
var k = Ce;
import { useEffect as ge, useRef as Re } from "react";
function he(e, r) {
  let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
  let t = Re(!0);
  ge(t.current || !n ? () => {
    t.current = !1;
  } : e, r);
}
var l = he;
function D() {}
function h(e, r, n, t) {
  return De(e, t) || be(e, r, n, t);
}
function De(e, r) {
  return e.editor.getModel(te(e, r));
}
function be(e, r, n, t) {
  return e.editor.createModel(r, n, t ? te(e, t) : void 0);
}
function te(e, r) {
  return e.Uri.parse(r);
}
function Oe(_ref3) {
  let {
    original: e,
    modified: r,
    language: n,
    originalLanguage: t,
    modifiedLanguage: a,
    originalModelPath: m,
    modifiedModelPath: E,
    keepCurrentOriginalModel: g = !1,
    keepCurrentModifiedModel: N = !1,
    theme: x = "light",
    loading: P = "Loading...",
    options: y = {},
    height: V = "100%",
    width: z = "100%",
    className: F,
    wrapperProps: j = {},
    beforeMount: A = D,
    onMount: q = D
  } = _ref3;
  let [M, O] = re(!1),
    [T, s] = re(!0),
    u = S(null),
    c = S(null),
    w = S(null),
    d = S(q),
    o = S(A),
    b = S(!1);
  k(() => {
    let i = Se.init();
    return i.then(f => (c.current = f) && s(!1)).catch(f => f?.type !== "cancelation" && console.error("Monaco initialization: error:", f)), () => u.current ? I() : i.cancel();
  }), l(() => {
    if (u.current && c.current) {
      let i = u.current.getOriginalEditor(),
        f = h(c.current, e || "", t || n || "text", m || "");
      f !== i.getModel() && i.setModel(f);
    }
  }, [m], M), l(() => {
    if (u.current && c.current) {
      let i = u.current.getModifiedEditor(),
        f = h(c.current, r || "", a || n || "text", E || "");
      f !== i.getModel() && i.setModel(f);
    }
  }, [E], M), l(() => {
    let i = u.current.getModifiedEditor();
    i.getOption(c.current.editor.EditorOption.readOnly) ? i.setValue(r || "") : r !== i.getValue() && (i.executeEdits("", [{
      range: i.getModel().getFullModelRange(),
      text: r || "",
      forceMoveMarkers: !0
    }]), i.pushUndoStop());
  }, [r], M), l(() => {
    u.current?.getModel()?.original.setValue(e || "");
  }, [e], M), l(() => {
    let {
      original: i,
      modified: f
    } = u.current.getModel();
    c.current.editor.setModelLanguage(i, t || n || "text"), c.current.editor.setModelLanguage(f, a || n || "text");
  }, [n, t, a], M), l(() => {
    c.current?.editor.setTheme(x);
  }, [x], M), l(() => {
    u.current?.updateOptions(y);
  }, [y], M);
  let L = oe(() => {
      if (!c.current) return;
      o.current(c.current);
      let i = h(c.current, e || "", t || n || "text", m || ""),
        f = h(c.current, r || "", a || n || "text", E || "");
      u.current?.setModel({
        original: i,
        modified: f
      });
    }, [n, r, a, e, t, m, E]),
    U = oe(() => {
      !b.current && w.current && (u.current = c.current.editor.createDiffEditor(w.current, {
        automaticLayout: !0,
        ...y
      }), L(), c.current?.editor.setTheme(x), O(!0), b.current = !0);
    }, [y, x, L]);
  ne(() => {
    M && d.current(u.current, c.current);
  }, [M]), ne(() => {
    !T && !M && U();
  }, [T, M, U]);
  function I() {
    let i = u.current?.getModel();
    g || i?.original?.dispose(), N || i?.modified?.dispose(), u.current?.dispose();
  }
  return ke.createElement(H, {
    width: z,
    height: V,
    isEditorReady: M,
    loading: P,
    _ref: w,
    className: F,
    wrapperProps: j
  });
}
var ie = Oe;
var we = Te(ie);
import { useState as Ie } from "react";
import ce from "@monaco-editor/loader";
function Pe() {
  let [e, r] = Ie(ce.__getMonacoInstance());
  return k(() => {
    let n;
    return e || (n = ce.init(), n.then(t => {
      r(t);
    })), () => n?.cancel();
  }), e;
}
var Le = Pe;
import { memo as ze } from "react";
import We, { useState as ue, useEffect as W, useRef as C, useCallback as _e } from "react";
import Ne from "@monaco-editor/loader";
import { useEffect as Ue, useRef as ve } from "react";
function He(e) {
  let r = ve();
  return Ue(() => {
    r.current = e;
  }, [e]), r.current;
}
var se = He;
var _ = new Map();
function Ve(_ref4) {
  let {
    defaultValue: e,
    defaultLanguage: r,
    defaultPath: n,
    value: t,
    language: a,
    path: m,
    theme: E = "light",
    line: g,
    loading: N = "Loading...",
    options: x = {},
    overrideServices: P = {},
    saveViewState: y = !0,
    keepCurrentModel: V = !1,
    width: z = "100%",
    height: F = "100%",
    className: j,
    wrapperProps: A = {},
    beforeMount: q = D,
    onMount: M = D,
    onChange: O,
    onValidate: T = D
  } = _ref4;
  let [s, u] = ue(!1),
    [c, w] = ue(!0),
    d = C(null),
    o = C(null),
    b = C(null),
    L = C(M),
    U = C(q),
    I = C(),
    i = C(t),
    f = se(m),
    Q = C(!1),
    B = C(!1);
  k(() => {
    let p = Ne.init();
    return p.then(R => (d.current = R) && w(!1)).catch(R => R?.type !== "cancelation" && console.error("Monaco initialization: error:", R)), () => o.current ? pe() : p.cancel();
  }), l(() => {
    let p = h(d.current, e || t || "", r || a || "", m || n || "");
    p !== o.current?.getModel() && (y && _.set(f, o.current?.saveViewState()), o.current?.setModel(p), y && o.current?.restoreViewState(_.get(m)));
  }, [m], s), l(() => {
    o.current?.updateOptions(x);
  }, [x], s), l(() => {
    !o.current || t === void 0 || (o.current.getOption(d.current.editor.EditorOption.readOnly) ? o.current.setValue(t) : t !== o.current.getValue() && (B.current = !0, o.current.executeEdits("", [{
      range: o.current.getModel().getFullModelRange(),
      text: t,
      forceMoveMarkers: !0
    }]), o.current.pushUndoStop(), B.current = !1));
  }, [t], s), l(() => {
    let p = o.current?.getModel();
    p && a && d.current?.editor.setModelLanguage(p, a);
  }, [a], s), l(() => {
    g !== void 0 && o.current?.revealLine(g);
  }, [g], s), l(() => {
    d.current?.editor.setTheme(E);
  }, [E], s);
  let X = _e(() => {
    if (!(!b.current || !d.current) && !Q.current) {
      U.current(d.current);
      let p = m || n,
        R = h(d.current, t || e || "", r || a || "", p || "");
      o.current = d.current?.editor.create(b.current, {
        model: R,
        automaticLayout: !0,
        ...x
      }, P), y && o.current.restoreViewState(_.get(p)), d.current.editor.setTheme(E), g !== void 0 && o.current.revealLine(g), u(!0), Q.current = !0;
    }
  }, [e, r, n, t, a, m, x, P, y, E, g]);
  W(() => {
    s && L.current(o.current, d.current);
  }, [s]), W(() => {
    !c && !s && X();
  }, [c, s, X]), i.current = t, W(() => {
    s && O && (I.current?.dispose(), I.current = o.current?.onDidChangeModelContent(p => {
      B.current || O(o.current.getValue(), p);
    }));
  }, [s, O]), W(() => {
    if (s) {
      let p = d.current.editor.onDidChangeMarkers(R => {
        let G = o.current.getModel()?.uri;
        if (G && R.find(J => J.path === G.path)) {
          let J = d.current.editor.getModelMarkers({
            resource: G
          });
          T?.(J);
        }
      });
      return () => {
        p?.dispose();
      };
    }
    return () => {};
  }, [s, T]);
  function pe() {
    I.current?.dispose(), V ? y && _.set(m, o.current.saveViewState()) : o.current.getModel()?.dispose(), o.current.dispose();
  }
  return We.createElement(H, {
    width: z,
    height: F,
    isEditorReady: s,
    loading: N,
    _ref: b,
    className: j,
    wrapperProps: A
  });
}
var fe = Ve;
var de = ze(fe);
var Ft = de;
export { we as DiffEditor, de as Editor, Ft as default, _t as loader, Le as useMonaco };